// extracted by mini-css-extract-plugin
export default {"footer":"footer_qYHC","socialsMedias":"socialsMedias_ChHp","copyright":"copyright_VBya"};